import React from "react";
import Alert from "./Alert";
import * as c from "./alertConstants";

const InfoAlert = (props) => <Alert type={c.INFO} {...props} />;

export default InfoAlert;
